import * as React from 'react';
import { MdAdd } from 'react-icons/md';
import { SimpleFormProps, SimpleFormComponentProps } from 'app/infrastructure/simple-form/types';
import { SimpleFormValidationConfig, requiredValidation } from 'app/infrastructure/simple-form';
import { Subscription, ConsentType } from 'app/area/user-profile/my-notifications/types';
import { SmsModal } from 'app/area/user-profile/my-notifications/consents/sms-modal';
import { form, MyNotificationTranslation } from 'app/area/user-profile/my-notifications/constants';
import { ValidationProps, AddButton } from 'ui';
import { defaultSerializeMappings } from 'app/infrastructure/simple-form/serialize';

import styles from './add-sms-consent.scss';

interface AddConsentExternalProps {
  recipientId: number;
  fetchingSaveSubscription: boolean;
  sharedState?: any;
  validation: ValidationProps[];
  translation?: MyNotificationTranslation;
  formComponent: React.ComponentType<SimpleFormComponentProps>;
  loadConsents: () => void;
  saveSubscription: (id: number, subscription: Subscription, onSuccess: () => void) => void;
  verifyCode: (subscription: Subscription, onSuccess: () => void) => void;
  clearValidation: (fieldName: string) => void;
  clearConsent: () => void;
}

interface AddSmsConsentState {
  isOpen: boolean;
}

export type AddSmsConsentProps = AddConsentExternalProps & SimpleFormProps;

export class AddSmsConsent extends React.PureComponent<AddSmsConsentProps, AddSmsConsentState> {
  public state: Readonly<AddSmsConsentState> = {
    isOpen: false
  };

  private handleToggle = () => {
    this.props.clearConsent();
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  private onDone = () => {
    const {
      saveSubscription,
      sharedState: { id: recipientId },
      serialize,
      validate,
      translation,
      loadConsents
    } = this.props;

    const serializedForm = serialize(defaultSerializeMappings);
    const verificationCode = String(serializedForm[form.sms.verificationCode]);
    const subscription = {
      recipientId: Number(recipientId),
      type: ConsentType.sms,
      ...(!!verificationCode && { verificationCode }),
      value: {
        name: String(serializedForm.token),
        token: String(serializedForm.token)
      }
    };

    const validationConfig: SimpleFormValidationConfig = [
      requiredValidation(form.sms.phoneNumber)
    ];

    validate(validationConfig, () =>
      saveSubscription(undefined, subscription,
        () => {
          this.handleToggle();
          loadConsents();
        }), translation.validation_error);
  };

  public render() {
    const { fetchingSaveSubscription, translation } = this.props;
    return (<div className={styles.wrapper}>
      <AddButton
        icon={MdAdd}
        onClick={this.handleToggle}>
        {translation.add_sms_title}
      </AddButton>
      {this.state.isOpen
        && <SmsModal
          fetching={fetchingSaveSubscription}
          onDone={this.onDone}
          onClose={this.handleToggle}
          {...this.props} />}
    </div>);
  }
}
